//Removes html tags from text string
//Example: "<p>Vanguard Total Stock Market ETF</p>" returns "Vanguard Total Stock Market ETF"
export default function removeHtml(value) {
	return value ? value.replace(/<(?:.|\n)*?>/gm, "") : "";
}
